/**
 * Parses the AskQuestionCard's `Yes, and always allow <toolName>` option (shared-drive write confirmation gate).
 * Shared here so chat app + Outlook addin use the same regex, not drifting copies. Pure module, no React/Convex deps.
 */

const ALWAYS_ALLOW_PATTERN = /^\s*yes\s*,\s*and\s+always\s+allow\s+(\S+)\s*$/i;

export function extractAlwaysAllowToolName(option: string): string | null {
	const match = option.match(ALWAYS_ALLOW_PATTERN);
	return match ? match[1] : null;
}
